import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import {
	unRegisterTime,
	registerTime,
	resetTimer,
	stopTimer
} from '../actions/index';

import {
	Button
} from '../../node_modules/react-bootstrap/lib/';

import '../css/App.css';

import {
	Pedestrismo,
	PedestrismoBackup,
	RuralBike,
	CombinadaSimple,
	CombinadaSprint
} from '../constants/enums';


class ParticipantRegisterTouch extends Component {

	constructor(props) {

		super(props);


		this.handleOnClick =
			this.handleOnClick.bind(this);

		this.getStartOffset =
			this.getStartOffset.bind(this);

		this.canRegisterParticipant =
			this.canRegisterParticipant.bind(this);

		this.getParticipantStatus =
			this.getParticipantStatus.bind(this);
	}


	ordenar() {

		const orderedList =
			this.props.participantList
				.slice()
				.sort(
					(p1, p2) => {

						return (
							p1.number -
							p2.number
						);
					}
				);


		return orderedList;
	}


	/*
	 * =======================================================
	 * ESTADO DEL PARTICIPANTE
	 * =======================================================
	 *
	 * DNS:
	 *   dns = 1
	 *
	 * DSQ:
	 *   disqualified = 1
	 *
	 * DNS tiene prioridad solamente por seguridad,
	 * aunque el reducer evita que ambos estados
	 * convivan simultáneamente.
	 */
	getParticipantStatus(
		participant
	) {

		if (
			Number(
				participant.dns || 0
			) === 1
		) {

			return 'DNS';
		}


		if (
			Number(
				participant.disqualified || 0
			) === 1
		) {

			return 'DSQ';
		}


		return '';
	}


	/*
	 * Devuelve el offset de largada
	 * correspondiente a la distancia
	 * del participante.
	 *
	 * El valor está expresado en minutos.
	 */
	getStartOffset(
		participant
	) {

		if (
			!participant
		) {

			return 0;
		}


		if (
			this.props.competition !==
				Pedestrismo
			&&
			this.props.competition !==
				PedestrismoBackup
		) {

			return 0;
		}


		const participantDistance =
			String(
				participant.distance || ''
			).trim();


		const distance1 =
			String(
				this.props.distance1Type || ''
			).trim();


		const distance2 =
			String(
				this.props.distance2Type || ''
			).trim();


		const distance3 =
			String(
				this.props.distance3Type || ''
			).trim();


		if (
			distance1 !== ''
			&&
			participantDistance ===
				distance1
		) {

			return Number(
				this.props
					.distance1StartOffset || 0
			);
		}


		if (
			distance2 !== ''
			&&
			participantDistance ===
				distance2
		) {

			return Number(
				this.props
					.distance2StartOffset || 0
			);
		}


		if (
			distance3 !== ''
			&&
			participantDistance ===
				distance3
		) {

			return Number(
				this.props
					.distance3StartOffset || 0
			);
		}


		return 0;
	}


	/*
	 * Verifica que la distancia
	 * efectivamente ya haya largado.
	 *
	 * startedAt general
	 * +
	 * offset de la distancia
	 */
	canRegisterParticipant(
		participant
	) {

		const startOffset =
			this.getStartOffset(
				participant
			);


		const offsetMs =
			startOffset *
			60 *
			1000;


		const effectiveStart =
			Number(
				this.props.startedAt || 0
			) +
			offsetMs;


		const now =
			new Date().getTime();


		return (
			now >=
			effectiveStart
		);
	}


	handleOnClick(
	e,
	participant,
	index
) {

	e.preventDefault();


	if (
		this.props.startedAt <= 0
	) {

		return;
	}


	/*
	 * ===================================================
	 * CLICK IZQUIERDO / TOUCH
	 * ===================================================
	 */
	if (
		e.type === 'click'
	) {

		const isDNS =
			Number(
				participant.dns || 0
			) === 1;


		const isDNF =
			Number(
				participant.dnf || 0
			) === 1;


		const isDSQ =
			Number(
				participant.disqualified || 0
			) === 1;


		/*
		 * =================================================
		 * BLOQUEAR ESTADOS ESPECIALES
		 * =================================================
		 *
		 * Si el atleta está marcado como:
		 *
		 * DNS
		 * DNF
		 * DSQ
		 *
		 * NO se permite registrar una llegada mediante
		 * click/touch.
		 *
		 * Primero debe hacerse clic derecho para ejecutar
		 * unRegisterTime() y limpiar el estado.
		 */
		if (
			isDNS ||
			isDNF ||
			isDSQ
		) {

			let status = '';


			if (
				isDNF
			) {

				status = 'DNF';

			} else if (
				isDSQ
			) {

				status = 'DSQ';

			} else if (
				isDNS
			) {

				status = 'DNS';
			}


			console.log(
				'Registro touch bloqueado por estado:',
				participant.number,
				status,
				'- Debe resetear el atleta con clic derecho.'
			);


			return;
		}


		/*
		 * =================================================
		 * REGISTRO NORMAL
		 * =================================================
		 */
		if (
			this.props.startedAt > 0
			&&
			(
				(
					(
						this.props.competition ===
							PedestrismoBackup

						||

						this.props.competition ===
							Pedestrismo

						||

						this.props.competition ===
							RuralBike

						||

						this.props.competition ===
							CombinadaSimple
					)

					&&

					participant.registeredTime1 ===
						0
				)

				||

				this.props.competition ===
					CombinadaSprint
			)
		) {

			const startOffset =
				this.getStartOffset(
					participant
				);


			/*
			 * Validar que su largada ya ocurrió.
			 */
			if (
				!this.canRegisterParticipant(
					participant
				)
			) {

				console.log(
					'Registro bloqueado:',
					participant.number,
					'Distancia:',
					participant.distance,
					'Offset:',
					startOffset,
					'min',
					'- La distancia todavía no largó'
				);


				return;
			}


			console.log(
				'Registro touch:',
				participant.number,
				'Distancia:',
				participant.distance,
				'Offset:',
				startOffset,
				'min'
			);


			setTimeout(
				() => {

					this.props.registerTime(
						index,
						this.props.competition,
						startOffset
					);

				},
				1
			);
		}


		return;
	}


	/*
	 * =====================================================
	 * CLICK DERECHO
	 * =====================================================
	 *
	 * Elimina tiempo y limpia estados especiales.
	 *
	 * Después de este reset el atleta vuelve a quedar
	 * disponible para registrar una llegada mediante
	 * touch o teclado.
	 */
	if (
		e.type ===
			'contextmenu'
	) {

		console.log(
			'Reset atleta:',
			participant.number
		);


		setTimeout(
			() => {

				this.props.unRegisterTime(
					index,
					this.props.competition
				);

			},
				1
		);
	}
}


	getPartials(
		participant
	) {

		/*
		 * Si tiene estado especial,
		 * mostramos eso antes que parciales.
		 */
		const status =
			this.getParticipantStatus(
				participant
			);


		if (
			status !== ''
		) {

			return (
				' (' +
				status +
				')'
			);
		}


		if (
			this.props.competition ===
				PedestrismoBackup

			||

			this.props.competition ===
				Pedestrismo

			||

			this.props.competition ===
				RuralBike

			||

			this.props.competition ===
				CombinadaSimple
		) {

			return "";
		}


		if (
			participant.registeredTime2 >
				0
		) {

			return " (2)";
		}


		if (
			participant.registeredTime1 >
				0
		) {

			return " (1)";
		}


		return "";
	}


	render() {

		return this
			.ordenar()
			.map(
				(
					participant,
					index
				) => {

					let style =
						"default";


					const isDNS =
						Number(
							participant.dns || 0
						) === 1;


					const isDSQ =
						Number(
							participant.disqualified || 0
						) === 1;


					/*
					 * =================================================
					 * DNS / DSQ
					 * =================================================
					 *
					 * Aplica a TODAS las competencias.
					 */
					if (
						isDNS
					) {

						style = "warning";

					} else if (
						isDSQ
					) {

						style = "danger";

					} else {


						/*
						 * =============================================
						 * PEDESTRISMO / RURAL /
						 * COMBINADA SIMPLE
						 * =============================================
						 */
						if (
							this.props.competition ===
								PedestrismoBackup

							||

							this.props.competition ===
								Pedestrismo

							||

							this.props.competition ===
								RuralBike

							||

							this.props.competition ===
								CombinadaSimple
						) {

							if (
								participant.registeredTime1 >
									0
							) {

								style =
									"primary";
							}
						}


						/*
						 * =============================================
						 * COMBINADA SPRINT
						 * =============================================
						 */
						if (
							this.props.competition ===
								CombinadaSprint
						) {

							/*
							 * Parcial 1
							 */
							if (
								participant.registeredTime1 >
									0

								&&

								participant.registeredTime2 ===
									0
							) {

								style =
									"primary";
							}


							/*
							 * Parcial 2
							 */
							if (
								participant.registeredTime2 >
									0
							) {

								style =
									"info";
							}
						}
					}


					return (

						<div
							key={
								participant.id
							}
						>

							<Button
								block

								bsSize="small"

								onContextMenu={
									(e) =>
										this.handleOnClick(
											e,
											participant,
											index
										)
								}

								bsStyle={
									style
								}

								onClick={
									(e) =>
										this.handleOnClick(
											e,
											participant,
											index
										)
								}
							>

								{
									participant.number
								}

								{' '}

								{
									this.getPartials(
										participant
									)
								}

							</Button>

						</div>
					);
				}
			);
	}
}


function mapDispatchToProps(
	dispatch
) {

	return bindActionCreators(
		{
			unRegisterTime,
			registerTime,
			resetTimer,
			stopTimer
		},
		dispatch
	);
}


function mapStateToProps(
	state
) {

	const {
		participantList
	} =
		state.reducerRegisterTime;


	const {
		startedAt
	} =
		state.reducerTimer;


	const {
		competition,

		distance1Type,
		distance1StartOffset,

		distance2Type,
		distance2StartOffset,

		distance3Type,
		distance3StartOffset

	} =
		state.reducerRegisterInfo;


	return {

		startedAt,

		participantList,

		competition,

		distance1Type,
		distance1StartOffset,

		distance2Type,
		distance2StartOffset,

		distance3Type,
		distance3StartOffset
	};
}


export default connect(
	mapStateToProps,
	mapDispatchToProps
)(
	ParticipantRegisterTouch
);



// WEBPACK FOOTER //
// ./src/containers/participant-list-touch.js